<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 表单查询 -->
    <el-form ref="form" :inline="true" :model="form" label-width="80px">
      <el-form-item label="分区名称">
        <el-select v-model="form.name" placeholder="全部" clearable>
          <el-option
            v-for="(v, i) in fenquArr"
            :key="i"
            :label="v.regionName"
            :value="v.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="项目时间">
        <el-date-picker
          v-model="form.startTime"
          format="yyyy-MM-dd"
          type="date"
          placeholder="开始日期"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        至
        <el-date-picker
          v-model="form.endTime"
          :picker-options="pickerOptionsEnd"
          format="yyyy-MM-dd"
          type="date"
          placeholder="结束日期"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getList()">查询</el-button>
        <el-button @click="reset">重置</el-button>
      </el-form-item>
    </el-form>

    <!-- 表格 -->
    <el-table :data="tableData" border stripe style="width: 100%">
      <el-table-column
        type="index"
        :index="indexMethod"
        label="序号"
        width="50"
        fixed="left"
      >
      </el-table-column>
      <el-table-column prop="name" label="分区名称"> </el-table-column>
      <!-- <el-table-column prop="companyName" label="所属企业"> </el-table-column> -->
      <el-table-column prop="endTime" label="是否开启">
        <template slot-scope="scope">
          <span v-text="scope.row.state === false ? '关闭' : '开启'"></span>
        </template>
      </el-table-column>
      <el-table-column prop="num" label="接卡总数"> </el-table-column>
      <el-table-column prop="money" label="接卡金额（元）">
        <template slot-scope="scope">
          <span v-text="scope.row.totalPrice ? scope.row.totalPrice : 0"></span>
        </template>
      </el-table-column>

      <el-table-column prop="startTime" label="开始日期"> </el-table-column>
      <el-table-column prop="endTime" label="结束日期"> </el-table-column>

      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleDetail(scope.row)"
            >详情</el-button
          >
          <el-button type="text" size="small" @click="handleEdit(scope.row)"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页器 -->
    <el-pagination
      class="mgt-20"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[5, 20, 30, 40, 50]"
      :page-size="pageSize"
      layout=" prev, pager, next"
      :total="total"
    >
    </el-pagination>
    <!-- 编辑弹框 -->
    <el-dialog
      title="编辑"
      :visible.sync="editVisible"
      width="30%"
      top="30vh"
      center
      :close-on-click-modal="false"
    >
      <el-form ref="editForm" :model="editForm" label-width="80px">
        <el-form-item label="分区名称">
          <el-input v-model="editForm.name" disabled></el-input>
        </el-form-item>
        <el-form-item label="开始时间">
          <el-input v-model="editForm.startTime" disabled></el-input>
        </el-form-item>
        <el-form-item label="结束时间">
          <el-input v-model="editForm.endTime" disabled></el-input>
        </el-form-item>
        <el-form-item label="是否开启">
          <el-input v-model="editForm.isOpen" disabled></el-input>
        </el-form-item>

        <el-form-item
          v-for="(v, i) in editForm.staffArr"
          :key="i"
          :label="'员工' + (i + 1)"
          :prop="'staffArr.' + i + '.staff'"
          :rules="[
            {
              required: true,
              message: '请选择员工',
              trigger: 'blur',
            },
          ]"
        >
          <div class="flex">
            <el-select filterable v-model="v.staff" placeholder="请选择员工">
              <el-option
                v-for="v2 in peopleArr"
                :key="v2.id"
                :label="v2.name"
                :value="v2.id"
              ></el-option>
            </el-select>
            <el-button
              class="mgl-10"
              v-if="i === editForm.staffArr.length - 1"
              @click="addStaff"
              >新增</el-button
            >
            <el-button
              class="mgl-10"
              type="danger"
              v-if="i !== 0"
              @click="delStaff(v)"
              >删除</el-button
            >
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="mgr-30" @click="editVisible = false">取 消</el-button>
        <el-button type="primary" @click="editSure('editForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";

import { handleConfirm, handleAlert } from "../../components/UtilsIf";
export default {
  components: {
    breadcrumbs,
  },
  data() {
    return {
      pickerOptionsEnd: {
        disabledDate: (time) => {
          let beginDateVal = this.form.startTime;
          if (beginDateVal) {
            return (
              time.setHours(0, 0, 0, 0) <
              new Date(beginDateVal).setHours(0, 0, 0, 0)
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },

      pickerOptionsEnd2: {
        disabledDate: (time) => {
          let beginDateVal = this.addForm.startTime;
          if (beginDateVal) {
            return (
              time.setHours(0, 0, 0, 0) <
              new Date(beginDateVal).setHours(0, 0, 0, 0)
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      form: {},
      tableData: [],
      // 分页数据
      page: 1, // 当前页，默认
      pageSize: 20, //每页显示多少条数据，默认
      total: 50, // 数据总条数
      dialogVisible: false,
      addForm: {
        name: "",
        startTime: "",
        endTime: "",
        companyName: "",
        staffArr: [{ staff: "" }],
        isOpen: "",
      },
      funTit: null,
      peopleArr: [],
      id: null,
      qiyeArr: [],
      companyName: null,
      editVisible: false,
      editForm: {
        name: "",
        startTime: "",
        endTime: "",
        isOpen: "",
        staffArr: [],
      },
      fenquArr: [],
    };
  },
  watch: {
    "form.startTime"() {
      if (this.form.startTime == null) {
        this.form.endTime = null;
      }
    },
    "addForm.startTime"() {
      if (this.addForm.startTime == null) {
        this.addForm.endTime = null;
      }
    },
  },
  created() {
    this.getList();
    this.getPeople();
    this.getFenqu();
  },
  methods: {
    // 分区下拉
    getFenqu() {
      this.$api.marketing.allZonePull().then((res) => {
        if (res.code === 200) {
          this.fenquArr = res.data;
        }
      });
    },
    // 编辑确定
    editSure(d) {
      this.$refs[d].validate((valid) => {
        if (valid) {
          handleConfirm("确定保存吗?", "info")
            .then(() => {
              let staffIdArr = [];
              this.editForm.staffArr.forEach((v) => {
                staffIdArr.push(v.staff);
              });
              this.qiyeArr.forEach((v) => {
                if (v.id === this.editForm.companyName) {
                  this.companyName = v.companyName;
                }
              });
              this.$api.waterCard
                .jiekabianji({
                  endTime: this.editForm.endTime,
                  staffId: staffIdArr,
                  startTime: this.editForm.startTime,
                  state: this.editForm.isOpen === "开启" ? true : false,
                  id: this.id,
                })
                .then((res) => {
                  if (res.code === 200) {
                    handleAlert("保存成功", "success");
                    this.getList();
                    this.editVisible = false;
                  }
                });
            })
            .catch(() => {
              return;
            });
        } else {
          return false;
        }
      });
    },

    handleEdit(row) {
      this.id = row.id;
      this.editVisible = true;
      this.editForm.name = row.name;
      this.editForm.isOpen = row.state === false ? "关闭" : "开启";
      let arr = row.staffId.split(",");
      this.editForm.staffArr = [];
      arr.forEach((v) => {
        this.editForm.staffArr.push({ staff: Number(v) });
      });
      this.editForm.startTime = row.startTime;
      this.editForm.endTime = row.endTime;
      this.id = row.id;
      this.$nextTick(() => {
        //清楚表单内容
        this.$refs.editForm.clearValidate();
      });
    },
    getPeople() {
      this.$api.zone.peoplePull().then((res) => {
        if (res.code === 200) {
          this.peopleArr = res.data.list;
        }
      });
    },
    handleDetail(row) {
      this.$router.push({
        path: "/waterCard/receiverDetail",
        query: {
          id: row.id,
        },
      });
    },

    addStaff() {
      this.editForm.staffArr.push({ staff: "" });
    },

    delStaff(item) {
      var index = this.editForm.staffArr.indexOf(item);
      if (index !== -1) {
        this.editForm.staffArr.splice(index, 1);
      }
    },

    getList(pageNum) {
      if (!pageNum) {
        this.page = 1;
      }
      this.$api.waterCard
        .projectList({
          regionId: this.form.name,
          pageNum: this.page,
          pageSize: this.pageSize,
          startTime: this.form.startTime,
          endTime: this.form.endTime,
        })
        .then((res) => {
          if (res.code === 200) {
            this.tableData = res.data.rows;
            this.tableData.forEach((v) => {
              v.startTime = v.startTime.substr(0, 10);
              v.endTime = v.endTime.substr(0, 10);
            });
            this.total = res.data.total;
          }
        });
    },

    reset() {
      this.form = { startTime: "", endTime: "" };
      this.getList();
    },
    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },

    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList(this.page);
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChange(val) {
      this.page = val;
      this.getList(this.page);
    },
  },
};
</script>

<style lang="scss" scoped>
.el-dialog {
  .el-date-editor {
    width: 100% !important;
  }
}
</style>
